<ng-container *ngIf="hasMarkOptions">
  <capra-icon-button
    class="layer-menu-icon"
    icon="icon-gear"
    size="medium"
    aria-label="Layer options menu"
    data-test="layer-options-menu-button"
    [matMenuTriggerFor]="isDisabled ? null : menu"
    [disabled]="isDisabled"
    capraTooltip
    [tooltipContent]="tooltipText"
    [tooltipInteractive]="false"
    [tooltipDelay]="[750, 0]"
    tooltipPlacement="bottom"
  >
  </capra-icon-button>
  <mat-menu #menu="matMenu" class="chart-menu">
    <ng-container [ngSwitch]="markType">
      <mode-bar-options-menu
        *ngSwitchCase="'Bar'"
        [model]="model"
        [encoding]="encoding"
        [seriesField]="seriesField"
        [markLayerOptions]="markLayerOptions"
        (layerOptionsChanged)="onMarkOptionsChanged($event)"
      ></mode-bar-options-menu>
      <mode-line-options-menu
        *ngSwitchCase="'Line'"
        [encoding]="encoding"
        [seriesField]="seriesField"
        [markLayerOptions]="markLayerOptions"
        (layerOptionsChanged)="onMarkOptionsChanged($event)"
      ></mode-line-options-menu>
      <mode-area-options-menu
        *ngSwitchCase="'Area'"
        [markLayerOptions]="markLayerOptions"
        (layerOptionsChanged)="onMarkOptionsChanged($event)"
      ></mode-area-options-menu>
    </ng-container>
  </mat-menu>
</ng-container>
